// Input Type 13:00
export const getHoursAndMinutesFromString = (string) => {
  const [hours, minutes] = string.split(':');

  return { hours: Number(hours), minutes: Number(minutes) };
};
